import { render, staticRenderFns } from "./InvoiceInfoSection.vue?vue&type=template&id=ec4a7b78&scoped=true&"
import script from "./InvoiceInfoSection.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInfoSection.vue?vue&type=style&index=0&id=ec4a7b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4a7b78",
  null
  
)

export default component.exports